// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SBId","field":"styles_field__2FOPL","fieldCol":"styles_fieldCol__3Yitt","diffCol":"styles_diffCol__qoGqH","diff":"styles_diff__nl7G0"};